import React from 'react';
import { Switch, Route } from 'react-router-dom';
import RefereeDashboard from '../components/Dashboard';

const Router = () => {
  return (
    <main>
      <Switch>
        <Route component={RefereeDashboard} />
      </Switch>
    </main>
  );
};

export default Router;



// WEBPACK FOOTER //
// ./src/private/referee/routes/index.js